import { INavData } from '@coreui/angular';

export const navItems4: INavData[] = [
  {
    name: 'Dashboard',
    url: '/courier/dashboard',
    icon: 'icon-puzzle'
  },
  {
    name: 'Master',
    url: '/courier/master',
    icon: 'icon-puzzle',
    children: [
      
      {
        name: 'Branch Master',
        url: '/courier/master/branch',
        icon: 'icon-puzzle'
      },
      {
        name: 'City Master',
        url: '/courier/master/city',
        icon: 'icon-puzzle'
      },
      {
        name: 'Pincode Master',
        url: '/courier/master/pincode',
        icon: 'icon-puzzle'
      },
      {
        name: 'Client Master',
        url: '/courier/master/client',
        icon: 'icon-puzzle'
      },
      {
        name: 'Service Tax Master',
        url: '/courier/master/servicetax',
        icon: 'icon-puzzle'
      },
      {
        name: 'Fuel Master',
        url: '/courier/master/fuel',
        icon: 'icon-puzzle'
      },
      {
        name: 'Docket Master',
        url: '/courier/master/docket',
        icon: 'icon-puzzle'
      },
      {
        name: 'FOV Master',
        url: '/courier/master/fov',
        icon: 'icon-puzzle'
      },
      {
        name: 'Status Master',
        url: '/courier/master/status',
        icon: 'icon-puzzle'
      },
      {
        name: 'Mode Master',
        url: '/courier/master/mode',
        icon: 'icon-puzzle'
      },
      {
        name: 'Service Type Master',
        url: '/courier/master/servicetype',
        icon: 'icon-puzzle'
      },
      {
        name: 'Volumetrice Master',
        url: '/courier/master/materialcal',
        icon: 'icon-puzzle'
      },
      {
        name: 'Rate Master',
        url: '/courier/master/rate',
        icon: 'icon-puzzle'
      },
      {
        name: 'Vendor Master',
        url: '/courier/master/vendor',
        icon: 'icon-puzzle'
      },
      {
        name: 'Transport Master',
        url: '/courier/master/transport',
        icon: 'icon-puzzle'
      },
      {
        name: 'Employee Master',
        url: '/courier/master/employee',
        icon: 'icon-puzzle'
      },
      {
        name: 'Reason Master',
        url: '/courier/master/reason',
        icon: 'icon-puzzle'
      },
      {
        name: 'Airline Master',
        url: '/courier/master/airline',
        icon: 'icon-puzzle'
      },
      {
        name: 'Flight Master',
        url: '/courier/master/flight',
        icon: 'icon-puzzle'
      }
    ]},
    {
      name: 'Entries',
      url: '/courier/entry',
      icon: 'icon-puzzle',
      children: [
        
        {
          name: 'Shipment Booking',
          url: '/courier/entry/bookingold',
          icon: 'icon-puzzle'
        },
        
        {
          name: 'Shipment Forwarding',
          url: '/courier/entry/forwarding',
          icon: 'icon-puzzle'
        },        
        {
          name: 'Proof Of Delivery',
          url: '/courier/entry/pod',
          icon: 'icon-puzzle'
        },
        {
          name: 'Shipment Status',
          url: '/courier/entry/podstatus',
          icon: 'icon-puzzle'
        },
        {
          name: 'RTO Entry',
          url: '/courier/entry/rto',
          icon: 'icon-puzzle'
        },
        {
          name: 'POD Upload',
          url: '/courier/entry/podupload',
          icon: 'icon-puzzle'
        },
        {
          name: 'Runsheet Upload',
          url: '/courier/entry/runsheetupload',
          icon: 'icon-puzzle'
        }
      ]},
      {
        name: 'Manifest',
        url: '/courier/manifest',
        icon: 'icon-puzzle',
        children:[
          {
            name: 'Create Manifest',
            url: '/courier/manifest/manifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'View Manifest',
            url: '/courier/manifest/viewmanifest',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Inscan',
        url: '/courier/inscan',
        icon: 'icon-puzzle',
        children: [
          {
            name: 'Inscan Manifest',
            url: '/courier/inscan/inscanmanifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'Inscan AWBNo',
            url: '/courier/inscan/inscanawb',
            icon: 'icon-puzzle'
          },
          {
            name: 'Manifest Tally',
            url: '/courier/inscan/manifesttally',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Runsheet',
        url: '/courier/drs',
        icon: 'icon-puzzle',
        children:[
          {
            name: 'Create Runsheet',
            url: '/courier/drs/drs',
            icon: 'icon-puzzle'
          },
          {
            name: 'View Runsheet',
            url: '/courier/drs/viewdrs',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Invoice',
        url: '/courier/invoice',
        icon: 'icon-puzzle',
        children:[
          {
            name: 'Generate Invoice',
            url: '/courier/invoice/generateinvoice',
            icon: 'icon-puzzle'
          },
          {
            name: 'Generate Invoice(Cash)',
            url: '/courier/invoice/generateinvoicecash',
            icon: 'icon-puzzle'
          },
          {
            name: 'View Invoice',
            url: '/courier/invoice/viewinvoice',
            icon: 'icon-puzzle'
          },
          {
            name: 'UnBilled Statement',
            url: '/courier/report/unbilled',
            icon: 'icon-puzzle'
          },
          {
            name: 'Sales Register',
            url: '/courier/report/salesregister',
            icon: 'icon-puzzle'
          }
        ]
      },
      {
        name: 'Shipment Query',
        url: '/courier/report/shipmentquery',
        icon: 'icon-puzzle'
      },
      {
        name: 'Track & Trace',
        url: '/courier/report/tracktrace',
        icon: 'icon-puzzle'
      },
      {
        name: 'User Management',
        url: '/courier/user',
        icon: 'icon-puzzle'
      },
      {
        name: 'Reports',
        url: '/courier/report',
        icon: 'icon-puzzle',
        children: [
          
          {
            name: 'Status',
            url: '/courier/report/status',
            icon: 'icon-puzzle'
          },
          {
            name: 'Status MIS',
            url: '/courier/report/statusmis',
            icon: 'icon-puzzle'
          },
          {
            name: 'Booking Statement',
            url: '/courier/report/bookingstatement',
            icon: 'icon-puzzle'
          },
          
          {
            name: 'Booking Summary',
            url: '/courier/report/bookingsummary',
            icon: 'icon-puzzle'
          },
          {
            name: 'Booking MIS',
            url: '/courier/report/bookingmis',
            icon: 'icon-puzzle'
          },
          {
            name: 'Check List',
            url: '/courier/report/checklist',
            icon: 'icon-puzzle'
          },
          {
            name: 'Manifest',
            url: '/courier/report/manifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'UnManifest',
            url: '/courier/report/unmanifest',
            icon: 'icon-puzzle'
          },
          {
            name: 'Branch MIS',
            url: '/courier/report/branchmis',
            icon: 'icon-puzzle'
          },
          {
            name: 'CNote Print',
            url: '/courier/report/cnoteprint',
            icon: 'icon-puzzle'
          },
          {
            name: 'Manifest Print',
            url: '/courier/report/manifestprint',
            icon: 'icon-puzzle'
          },
          {
            name: 'Runsheet Print',
            url: '/courier/report/drsprint',
            icon: 'icon-puzzle'
          },
          {
            name: 'Invoice Print',
            url: '/courier/report/invoiceprint',
            icon: 'icon-puzzle'
          },
          {
            name: 'Label Print',
            url: '/courier/report/labelprint',
            icon: 'icon-puzzle'
          }
        ]},
        {
          name: 'Log Out',
          url: 'login',
          icon: 'icon-puzzle'
        }
    
  
  
];
